import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import SystemUpdateOutlinedIcon from '@mui/icons-material/SystemUpdateOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';
import { CallToActionEnum } from '@/graphql/types';

export const CTAMapper = {
  [CallToActionEnum.Call]: {
    label: 'Call',
    icon: PhoneInTalkOutlinedIcon,
    order: 1,
  },

  [CallToActionEnum.Download]: {
    label: 'Download',
    icon: DownloadOutlinedIcon,
    order: 2,
  },
  [CallToActionEnum.Email]: {
    label: 'Email',
    icon: EmailOutlinedIcon,
    order: 3,
  },
  [CallToActionEnum.App]: {
    label: 'Get App',
    icon: SystemUpdateOutlinedIcon,
    order: 4,
  },
  [CallToActionEnum.GetApp]: {
    label: 'Get App',
    icon: SystemUpdateOutlinedIcon,
    order: 5,
  },
  [CallToActionEnum.JoinMeeting]: {
    label: 'Join Meeting',
    icon: VideocamOutlinedIcon,
    order: 6,
  },
  [CallToActionEnum.LearnMore]: {
    label: 'Learn More',
    icon: PublicOutlinedIcon,
    order: 7,
  },
  [CallToActionEnum.Order]: {
    label: 'Order',
    icon: ShoppingCartOutlinedIcon,
    order: 8,
  },
  [CallToActionEnum.Register]: {
    label: 'Register',
    icon: HowToRegOutlinedIcon,
    order: 9,
  },
  [CallToActionEnum.RSVP]: {
    label: 'RSVP',
    icon: HowToRegOutlinedIcon,
    order: 10,
  },
  [CallToActionEnum.SignUp]: {
    label: 'Sign Up',
    icon: HowToRegOutlinedIcon,
    order: 11,
  },
  [CallToActionEnum.Subscribe]: {
    label: 'Subscribe',
    icon: RssFeedIcon,
    order: 12,
  },
  [CallToActionEnum.Survey]: {
    label: 'Survey',
    icon: PollOutlinedIcon,
    order: 13,
  },
};
